import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  background: #F9F9F9;
  padding: 0 0 5rem 0;
  padding-left:250px;
`;
export const Content = styled.div`
  width: 100%;
  background: #F9F9F9;
  height: 100%;
  padding: 0 1rem;
  margin-bottom: 1rem;
  h2 {
    font-size: 1.2rem;
    border-bottom: 1px solid #c6c6c6;
    padding-bottom: .7rem;
    margin-top:1rem;
  }
`;

export const MainDashExternal = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 1rem;
  }
`;
export const MainDash = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: .5rem 1rem;
  gap: 1rem;
  background: #FFF;
  width: 100%;
  color: #000;
  border-radius: 6px;
`;
export const GridTemplate = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  min-height: ${props => props.isFlex ? "200px":"400px"};
  width: 100%;
  align-items: start;
`;
export const FlexTemplate = styled.div`
  display: flex;
  gap: 1rem;
  min-height:"200px";
  width: 100%;
  align-items:center;
  justify-content:flex-start;
  max-height:500px;
`;

export const BoxLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  width: 100%;
  position:relative;
  height: 100%;
`;

export const SearchButton = styled.div`
  padding: 0.5rem  1rem;
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  background: rgba(0, 0, 0, 0.2);
  transition: var(--transition);
  border-radius:6px;
  &:hover{
    cursor: pointer;
    background: #1b1c1d;
    color:#FFF;
  }
`;
export const ContainerPizza = styled.div`
  display: flex;
  align-items:center;
  justify-content:center;
  width: 100%;
  max-width: fit-content;
  gap: 1rem;
  background: #FFF;
  section {
    display: flex;
    height:100%;
    max-height: 250px;
    padding: 0 .5rem;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    background: #FFF;
    border-radius: 6px;
    box-sizing: border-box;
    width:auto;
    p {
      font-size: .8rem;
      font-weight: 500;
      padding: .5rem;
      margin:0;
    }
    canvas {
    }
  }
  
`;

export const SubTitle = styled.a`
  color: #0d0d0d;
  padding: 0;
  text-align: left;
  align-self: start;
  margin:0;
  font-size: 1.2rem;
  font-weight: 600;
  width: 100%;
  border-bottom: 1px solid #c6c6c6;
    padding-bottom: .7rem;
    b
  &:hover {
    color: #0d0d0d;
  }
`;
export const StyledLinkMenuNested = styled.div`
  width: 100%
`;